import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { Configuracion } from '../models/Util';

@Injectable({
  providedIn: 'root'
})
export class ConfiguracionService {

  private LIST_CONFIGURATION_PARAMETERS_URL = environment.apiUrl + "config/list"
  private PATCH_CONFIGURATION_PARAMETER_URL = environment.apiUrl + "config/"

  constructor(
    private httpClient: HttpClient
  ) { }

  listConfigurationParameters(): Observable<Configuracion[]> {
    return this.httpClient.get<Configuracion[]>(this.LIST_CONFIGURATION_PARAMETERS_URL)
  }

  patchConfigurationParameter(configID: number, configuration: Configuracion): Observable<Configuracion> {
    return this.httpClient.patch<Configuracion>(this.PATCH_CONFIGURATION_PARAMETER_URL + configID, configuration)
  }
}
